import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "../stores/auth";

import Login from "../views/Login.vue";
import Keys from "../views/Keys.vue";
import Online from "../views/Online.vue";
import Events from "../views/Events.vue";
import Builds from "../views/Builds.vue";

// meta.public 标记无需登录的页面；meta.title 用于顶部状态栏标题
const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", redirect: "/keys" },
    { path: "/login", component: Login, meta: { public: true, title: "控制台登录" } },
    { path: "/keys", component: Keys, meta: { title: "卡密管理", icon: "🔑" } },
    { path: "/online", component: Online, meta: { title: "在线监控", icon: "📡" } },
    { path: "/events", component: Events, meta: { title: "异常事件", icon: "⚠" } },
    { path: "/builds", component: Builds, meta: { title: "版本管理", icon: "🧬" } },
  ],
});

// 全局前置守卫：未登录访问受保护页面时跳登录页
router.beforeEach((to) => {
  const auth = useAuthStore();
  if (!to.meta.public && !auth.adminToken) return "/login";
  // 已登录还停在登录页时，直接进卡密页
  if (to.path === "/login" && auth.adminToken) return "/keys";
});

export default router;
